<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/move-step1')"></span>
    </div>
    <div class="title">请选择搬家车型</div>

      <div class="car-choose">
        <div class="car" :class="{ active: isActive('1')}" @click="orderUpdate('move_car','1');changeSlide(1)">面包车</div>
        <div class="car" :class="{ active: isActive('2')}" @click="orderUpdate('move_car','2');changeSlide(2)">小箱货</div>
        <div class="car" :class="{ active: isActive('3')}" @click="orderUpdate('move_car','3');changeSlide(3)">中箱货</div>
        <div class="car" :class="{ active: isActive('4')}" @click="orderUpdate('move_car','4');changeSlide(4)">大箱货</div>
        <div class="car" :class="{ active: isActive('5')}" @click="orderUpdate('move_car','5');changeSlide(5)">特大箱货</div>
      </div>
      <div>
        <swiper :options="swiperOption" ref="swiper">
          <!-- <swiper-slide><div class="carshow"><router-link :to="vehicle_id"><img src='../../assets/img/move/aevent.jpg'></router-link></div></swiper-slide> -->
          <swiper-slide><div class="carshow"><router-link :to="vehicle_id"><img src='../../assets/img/move/a.jpg'></router-link></div></swiper-slide>
          <swiper-slide><div class="carshow"><router-link :to="vehicle_id"><img src='../../assets/img/move/b.jpg'></router-link></div></swiper-slide>
          <swiper-slide><div class="carshow"><router-link :to="vehicle_id"><img src='../../assets/img/move/c.jpg'></router-link></div></swiper-slide>
          <swiper-slide><div class="carshow"><router-link :to="vehicle_id"><img src='../../assets/img/move/d.jpg'></router-link></div></swiper-slide>
          <swiper-slide><div class="carshow"><router-link :to="vehicle_id"><img src='../../assets/img/move/e.jpg'></router-link></div></swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"><span class="icon-chevron-left"></span></div>
          <div class="swiper-button-next" slot="button-next"><span class="icon-chevron-right"></span></div>
        </swiper>
      </div>

      <div class="car-detail" v-show="order.data.move_car === '1'">
        <div><span class="icon-point"></span> 长宽高 4.92 x 1.68 x 1.95 m </div>
        <div><span class="icon-point"></span> 装载体积 6 立方</div>
        <div><span class="icon-point"></span> 适合行李、小件家具搬运</div>
        <div class="more-detail">
          <span class="check-detail"><span class="icon-chevron-down"></span> <router-link :to="vehicle_id">查看面包车详情与资费</router-link></span>
        </div>
      </div>

      <div class="car-detail" v-show="order.data.move_car === '2'">
        <div><span class="icon-point"></span> 4.5吨升降机卡车 </div>
        <div><span class="icon-point"></span> 长宽高 6.2 x 2.2 x 3.6 m </div>
        <div><span class="icon-point"></span> 装载体积 19 立方</div>
        <div><span class="icon-point"></span> 适合一房或 Studio 户型</div>
        <div class="more-detail">
          <span class="check-detail"><span class="icon-chevron-down"></span> <router-link :to="vehicle_id">查看小型箱货详情与资费</router-link></span>
        </div>
      </div>

      <div class="car-detail" v-show="order.data.move_car === '3'">
        <div><span class="icon-point"></span> 6.5吨升降机卡车 </div>
        <div><span class="icon-point"></span> 长宽高 6.47 x 2.5 x 3.6 m </div>
        <div><span class="icon-point"></span> 装载体积 27 立方</div>
        <div><span class="icon-point"></span> 适合两房一厅户型搬家</div>
        <div class="more-detail">
          <span class="check-detail"><span class="icon-chevron-down"></span> <router-link :to="vehicle_id">查看中型箱货详情与资费</router-link></span>
        </div>
      </div>

      <div class="car-detail" v-show="order.data.move_car === '4'">
        <div><span class="icon-point"></span> 7.5吨升降机卡车 </div>
        <div><span class="icon-point"></span> 长宽高 7.83 x 2.5 x 3.4 m </div>
        <div><span class="icon-point"></span> 装载体积 30 立方</div>
        <div><span class="icon-point"></span> 适合三房一厅户型的搬家</div>
        <div class="more-detail">
          <span class="check-detail"><span class="icon-chevron-down"></span> <router-link :to="vehicle_id">查看大型箱货详情与资费</router-link></span>
        </div>
      </div>


      <div class="car-detail" v-show="order.data.move_car === '5'">
        <div><span class="icon-point"></span> 10吨升降机卡车 </div>
        <div><span class="icon-point"></span> 长宽高 11 x 2.5 x 3.6 m </div>
        <div><span class="icon-point"></span> 装载体积 41 立方</div>
        <div><span class="icon-point"></span> 适合三房两厅或三房以上户型的搬家</div>
        <div class="more-detail">
          <span class="check-detail"><span class="icon-chevron-down"></span> <router-link :to="vehicle_id">查看特大型箱货详情与资费</router-link></span>
        </div>
      </div>


      <div class="btn-box-fix">
        <div class="car-info" v-show="order.data.move_car === '1'">
          <div class="vehicle-stats" v-show="Object.keys(orderStats).length>0">近30天有<span class="color-orange">{{orderStats['homemove_num']}}</span>人选择到家搬家，好评率<span class="color-orange">{{orderStats['homemove_trade']}}%</span></div>
          <div><span class="icon-truck color-orange"></span> <span>面包车</span></div>
          <div><span class="icon-user color-orange"></span> <span>1名服务人员</span></div>
          <div><span class="icon-coin-dollar color-orange"></span> <span>每小时 $65</span></div>
        </div>
        <div class="car-info" v-show="order.data.move_car === '2'">
          <div class="vehicle-stats" v-show="Object.keys(orderStats).length>0">近30天有<span class="color-orange">{{orderStats['homemove_num']}}</span>人选择到家搬家，好评率<span class="color-orange">{{orderStats['homemove_trade']}}%</span></div>
          <div><span class="icon-truck color-orange"></span> <span>小箱货</span></div>
          <div><span class="icon-user color-orange"></span> <span>2名服务人员</span></div>
          <div><span class="icon-coin-dollar color-orange"></span> <span>每小时 $120</span></div>
        </div>
        <div class="car-info" v-show="order.data.move_car === '3'">
          <div class="vehicle-stats" v-show="Object.keys(orderStats).length>0">近30天有<span class="color-orange">{{orderStats['homemove_num']}}</span>人选择到家搬家，好评率<span class="color-orange">{{orderStats['homemove_trade']}}%</span></div>
          <div><span class="icon-truck color-orange"></span> <span>中箱货</span></div>
          <div><span class="icon-user color-orange"></span> <span>2名服务人员</span></div>
          <div><span class="icon-coin-dollar color-orange"></span> <span>每小时 $130</span></div>
        </div>
        <div class="car-info" v-show="order.data.move_car === '4'">
          <div class="vehicle-stats" v-show="Object.keys(orderStats).length>0">近30天有<span class="color-orange">{{orderStats['homemove_num']}}</span>人选择到家搬家，好评率<span class="color-orange">{{orderStats['homemove_trade']}}%</span></div>
          <div><span class="icon-truck color-orange"></span> <span>大箱货</span></div>
          <div><span class="icon-user color-orange"></span> <span>2名服务人员</span></div>
          <div><span class="icon-coin-dollar color-orange"></span> <span>每小时 $140</span></div>
        </div>
        <div class="car-info" v-show="order.data.move_car === '5'">
          <div class="vehicle-stats" v-show="Object.keys(orderStats).length>0">近30天有<span class="color-orange">{{orderStats['homemove_num']}}</span>人选择到家搬家，好评率<span class="color-orange">{{orderStats['homemove_trade']}}%</span></div>
          <div><span class="icon-truck color-orange"></span> <span>特大箱货</span></div>
          <div><span class="icon-user color-orange"></span> <span>2名服务人员</span></div>
          <div><span class="icon-coin-dollar color-orange"></span> <span>每小时 $150</span></div>
        </div>

        <div class="btn-container">
          <div class="btn active" @click="goto('/move-step3')" >下一步</div>
        </div>
      </div>
      <img :src="pixelURL('move','chexing')" class="hide">
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'step2',
  data () {
    return {
      order:{},
      orderStats:{},
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
    }
  },

  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper: function () {
      return this.$refs.swiper.swiper;
    },
    vehicle_id : function () {
      return "/move-vehicle?step=vehicle&v="+this.order.data.move_car;
    }, 

  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "move"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
    if (localStorage.orderStats) {
      this.orderStats = JSON.parse(localStorage.orderStats);
    }
  },
  mounted: function () {
    let suggest="";

    //如果本来就存过了move_car，就直接使用正在存的值
    if(this.order.data.move_car){
      suggest = this.order.data.move_car;
    }
    //如果是从搬家规模页（step1）进来的，网址会带一个fromScale参数；如果如此，则根据搬家规模给他重新推荐车型
    if(this.order.data.move_scale && this.$route.query.fromScale==1){
      this.$router.replace("/move-step2");
      switch (this.order.data.move_scale) {
        case "1":
          suggest = "1"
          break;
        case "2":
          suggest = "2"
          break;
        case "3":
          suggest = "4"
          break;
        default:
          console.log("Sorry, we are out of service.");
      }
    }
    //如果是从最终订单确认页，进来编辑的，则直接使用正在存的值
    if(this.order.data.move_car&&localStorage.isEditing){
      suggest = this.order.data.move_car;
    }
    this.orderUpdate('move_car',suggest);
    this.changeSlide(suggest);

    let that = this;
    that.swiper.on('slideChange', function () {
      let swiperIndex = that.swiper.activeIndex + 1;
      that.orderUpdate('move_car',swiperIndex.toString());
    });
  },
  methods: {
    changeSlide(key){
      key = key - 1;
      this.swiper.slideTo(key, 200, false)
    },

    isActive(val) {
      if(this.order.data.move_car==val){
        return true;
      }
      else{
        return false;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";


.container /deep/ .swiper-button-prev, .container /deep/ .swiper-button-next{
  font-size:2.4em;
  color:#bbb;
  margin-right: 18px;
}

.container /deep/ .swiper-button-prev, .container /deep/ .swiper-container-rtl .swiper-button-next{
  background:none;
}

.container /deep/ .swiper-button-next, .container /deep/ .swiper-container-rtl .swiper-button-prev{
  background:none;
}
.carshow{
  text-align:center;
  img{
    width:84%;
  }
}
.car-detail{
  margin-top:20px;
  font-size:0.9em;
  color:#666;
  text-align:center;
  .icon-point{
    color:#fe9567;
  }
}
.car-choose{
  border-bottom:1px solid #eee;
  width:86%;
  margin:1em auto 1.8em auto;
  display: flex;
  justify-content:space-around;
  .car{
    padding:0 0.2em 0 0.2em;
    font-size:0.9em;
  }
  .car.active{
    color:#fe9567;
    border-bottom: solid 3px #fe9567;
    padding-bottom:0.6em;
  }
}

.fade-leave-active {
  transition-duration: 0s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-name: breathe;
    -webkit-animation-duration: 1000ms;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-direction: alternate;
}

.car-info{
  position:relative;
  padding: 10px 30px 0 30px;
  text-align:left;
  color:#999;
  font-size:0.9em;
  display: flex;
  justify-content:space-around;
  .vehicle-stats{
    top:-70px;
    position:absolute;
    border-radius:50px;
    background:#f7f7f7;
    padding:6px 12px;
  }
}


@-webkit-keyframes breathe {
    0% {
      border: 2px solid #eeeeee;
    }

    100% {
      border: 2px solid #fad0be;
    }
}


</style>



// WEBPACK FOOTER //
// src/pages/move/step2.vue